import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guide-google-personal-account',
  templateUrl: './guide-google-personal-account.component.html',
  styleUrls: ['./guide-google-personal-account.component.scss']
})
export class GuideGooglePersonalAccountComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
